import { render, staticRenderFns } from "./ContactPersons.vue?vue&type=template&id=7a9ac1f5&scoped=true&"
import script from "./ContactPersons.vue?vue&type=script&lang=js&"
export * from "./ContactPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9ac1f5",
  null
  
)

export default component.exports